/**
 * Analytics Event Types
 * TrackingEvent değerleri direkt olarak dataLayer event adlarıdır
 */
export const TrackingEvent = {
  // User Events
  VIRTUAL_USER_INFO: "virtual_user_info",
  VIRTUAL_PV: "virtual_pv",

  // Search Events
  SEARCH_RESULT: "search_result",
  NO_SEARCH_RESULT: "no_search_result",
  SEARCH: "search",

  // Coupon Events
  SELECT_COUPON: "select_coupon",
  VIEW_COUPON: "view_coupon",
  COUPON_APPLIED: "coupon_applied",

  // Reservation Events
  CHECK_RESERVATION: "check_reservation",
  CALL_TO_CANCEL_RESERVATION: "call_to_cancel_reservation",
  SUPPORT_TO_CANCEL_RESERVATION: "support_to_cancel_reservation",

  // Switch Events
  PROMOTIONAL_BANNER_CLICKED: "promotional_banner_clicked",
  SWITCH_TO_FLIGHT: "switch_to_flight",
  SWITCH_TO_FERRY: "switch_to_ferry",

  // Filter & Sort Events
  FILTER_APPLIED: "filter_applied",
  SORTING_APPLIED: "sorting_applied",

  // E-commerce Events
  VIEW_ITEM_LIST: "view_item_list",
  SELECT_ITEM: "select_item",
  VIEW_ITEM: "view_item",
  ADD_TO_CART: "add_to_cart",
  ADD_TO_WISHLIST: "add_to_wishlist",
  BEGIN_CHECKOUT: "begin_checkout",
  EXTRA_SERVICE: "extra_service",
  ADD_PAYMENT_INFO: "add_payment_info",
  PURCHASE: "purchase",
  REFUND: "refund",

  // Invoice Events
  SAVE_INVOICE: "save_invoice",

  // Error Events
  SIGN_UP_FAILED: "sign_up_failed",
  LOGIN_FAILED: "login_failed",
  ERROR: "error",
  SHOWN_ERROR: "shown_error",

  // Authentication Events
  SIGN_UP: "sign_up",
  LOGIN: "login",

  // Credit Card Points Events
  QUERY_CREDIT_CARD_POINTS: "query_credit_card_points",
  CONVERT_TO_TURNA_POINTS: "convert_to_turna_points",
  CONVERT_TO_TURNA_POINTS_COMPLETE: "convert_to_turna_points_complete",

  // Promotion Events
  VIEW_PROMOTION: "view_promotion",
  SELECT_PROMOTION: "select_promotion",

  // CTA Click Events
  CTA_CLICK: "cta_click",
  CTA_CLICKED: "cta_clicked",

  // Hotel Map View (Haritada Göster)
  HOTEL_MAP_VIEW: "hotel_map_view",
};
